import { useEffect, useState, Suspense } from 'react'
import axios from 'axios'
import AnnounceJobOffer from './components/announceJobOffer'
import DashboardLayout from './layout'
import { useTranslation } from 'react-i18next'
import { API_BASE_URL, X_API_KEY } from '../../services/api'
import CookieManager from '../lib/CookiesManager'

const JobOffer = () => {
  const [userStatus, setUserStatus] = useState<string[]>([])
  const { t } = useTranslation()

  useEffect(() => {
    const fetchUserData = async () => {
      const email = CookieManager.getEmail()
      if (email) {
        try {
          const response = await axios.get(`${API_BASE_URL}/all/full`, {
            headers: { 'x-api-key': X_API_KEY },
          })
          if (response.data && Array.isArray(response.data.users)) {
            const users = response.data.users
            const user = users.find(
              (user: { email: string }) => user.email === email,
            )
            if (user && Array.isArray(user.status)) {
              setUserStatus(user.status)
            }
          } else {
            console.error(
              "La réponse de l'API n'est pas structurée comme attendu",
              response.data,
            )
          }
        } catch (error) {
          console.error(
            'Erreur lors de la récupération des données utilisateur',
            error,
          )
        }
      }
    }

    fetchUserData()
  }, [])

  let FormComponent: React.ComponentType<any> = () => <div />

  if (
    userStatus.includes(
      'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
    ) ||
    userStatus.includes('private, escort, massage')
  ) {
    FormComponent = AnnounceJobOffer
  }

  return (
    <DashboardLayout title={t('create-job-offer')}>
      <Suspense fallback={<div>{t('page-loading')}</div>}>
        {FormComponent && (
          <FormComponent
            userProfileFormProps={undefined}
            formData={undefined}
            handleFieldChange={function (): void {
              throw new Error('Function not implemented.')
            }}
          />
        )}
      </Suspense>
    </DashboardLayout>
  )
}

export default JobOffer
